module.exports = __webpack_public_path__ + "img/GreekTechHoplite3_ua.de938a1c.webp";